import React, { useEffect, useRef, useState } from 'react'
import { Box, Grid, MenuItem, Paper, Tab, Tabs } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FilterComponent, PageLoader, PopOverCTA, STableLoader } from '../../../shared_elements';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { RoleBaseAccess } from '../../../hoc';
import DeploymentBanner from '../../../shared_elements/components/DeploymentBanner';
import CashFlowListing from '../components/CashFlowListing';
import CashflowDetailsModal from '../components/CashflowDetailsModal';
import ReceivableCashflow from '../components/ReceivableCashflow';
import { trackActivity } from '../../../utils/mixpanel';
import { getCurrencyAc, getLesseeAc, getOwnerListApi } from '../../../shared_elements/actionCreators';
import { getAssetListApi } from '../../leases/apiServices';
import { getCashflowCategoriesApi, getTransactionTypesApi } from '../../settings/cashflow_categories/apiService';
import ExportFileTypeComp from '../../../shared_elements/components/ExportFileTypeComp';
import { exportCashFlowApi } from '../apiService';
import { enqueueSnackbar } from 'notistack';
import moment from 'moment';

const FleetCashflow = () => {
	const params = useParams();
	const dispatch = useDispatch();
	const [tabIndex, setTabIndex] = useState(0);
	const [isLoading, setLoading] = useState(false)
	const { leaseBasicDetails } = useSelector((state) => state.leases);
	const [cashFlowListing, setCashFlowListing] = useState({})
	const [cashflowDetailsModal, setCashflowDetailsModal] = useState({
		open: false,
		start_date: null,
		end_date: null,
		mode: "monthly",
	});
	const [mode, setMode] = useState("monthly");
	const [year, setYear] = useState(new Date().getFullYear());
	const [isExport, setExport] = useState(false)
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [assetList, setAssetList] = useState([]);
	const { lessee, lessor, currencies, owner } = useSelector((state) => state.leases);
	const [transactionTypes, setTransactionTypes] = useState([]);
	const [currency, setcurrency] = useState("USD");
	const [filter, setFilter] = useState({});
	const filterRef = useRef(filter);
	const [section, setSection] = useState([]);
	const statusLabel = [{ id: "draft", Label: "Draft" }, { id: "active", Label: "Active" }, { id: "closed", Label: "Closed" }, { id: "terminated", Label: "Terminated" }, { id: "on-hold", Label: "On-hold" }]
	const invoiceTypeOptions = [ { label: 'Maintenance Reserve', value: 1 }, { label: 'Rental', value: 2 }, { label: 'Penalty', value: 3 }, { label: 'Debit', value: 4 }, { label: 'Credit', value: 5 }, { label: 'Adhoc', value: 9 }, ];
	const showOnlyOption = [{value:'all',label:'All Section'},{value:'outflows',label:'Outflows Only'},{value:'inflows',label:'Inflows Only'}]
	const currencyOptions = currencies?.length > 0 ? currencies : [ { id: 27, code: 'GBP' }, { id: 3,  code: 'EURO' }, { id: 1,  code: 'USD' }, ];
	const currencyLabel = currency || "USD";
	const currencySymbol = currencyOptions.find( (cur) => String(cur.code) === String(currency) )?.symbol || "$";
	useEffect(() => {
		filterRef.current = filter;
	}, [filter])

	useEffect(() => {
		getCashFlowList('skeletonLoader', mode, year, currency, filterRef.current)
		trackActivity('Page Viewed',{ page_title: 'Fleet CashFlow'})
		if (!lessee?.length) {
			dispatch(getLesseeAc({}));
		}

		if (!lessor?.length) {
			dispatch(getOwnerListApi({}));
		}

		if (!currencies?.length) {
			dispatch(getCurrencyAc({}));
		}

		getAssetList();
		getTransactionTypes();
		getSections();
	}, [mode, year, currency])

	const getCashFlowList = (loaderType, selectedMode, selectedYear, selectedCurrency, query = {}) => {
		loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
		const apiQuery = { ...query };
		if (apiQuery.asset) {
			const selectedAssets = Array.isArray(apiQuery.asset) ? apiQuery.asset : apiQuery.asset.toString().split(',').filter(Boolean);
			apiQuery.asset = selectedAssets.map((key) => {
				const [id, assetType] = key.toString().split('_');
				return assetType ? `${id},${assetType}` : key;
			}).join(',');
		}
		const queryString = new URLSearchParams(apiQuery).toString();
		const hasDateRange = apiQuery?.start_date && apiQuery?.end_date;
		const url = `/cashflows?${hasDateRange ? '' : `year=${selectedYear}&`}mode=${selectedMode}&currency=${selectedCurrency}${queryString ? '&' + queryString : ''}`;
		globalGetService(url)
			.then(response => {
				if (checkApiStatus) {
					setCashFlowListing(response?.data)
					setFilter(query)
					loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
					if(response.data.statusCode === 400){
						enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					}
				}
				loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
			})
	}

	const getAssetList = () => {
		globalGetService(getAssetListApi({})).then(response => {
			if (checkApiStatus) {
				const formatted = (response?.data?.data || []).map(item => ({
					...item,
					unique_key: `${item.id}_${item.asset_type}`,
				}));
				setAssetList(formatted)
			}
		})
	}

	const getTransactionTypes = (query) => {
		globalGetService(getTransactionTypesApi(query))
			.then(response => {
				if (checkApiStatus(response)) {
					setTransactionTypes(response?.data?.data?.list);
				}
			})
	}

	const getSections = (query) => {
		globalGetService(getCashflowCategoriesApi(query))
			.then(response => {
				if (checkApiStatus(response)) {
					setSection(response?.data?.data?.list);
				}
			})
	}

	const handleCurrencyChange = (newMode) => {
		setcurrency(newMode)
	}

	const handleModeChange = (newMode) => {
		setMode(newMode.toLowerCase())
	}

	const today = new Date()
	const endDate = params?.leaseSlug &&leaseBasicDetails?.end_date ? new Date(leaseBasicDetails.end_date) : null

	const maxAllowedYear = endDate ? endDate.getFullYear() : today.getFullYear();

	const minAllowedYear = params?.leaseSlug &&leaseBasicDetails?.start_date
		? new Date(leaseBasicDetails.start_date).getFullYear()
		: 2000

	const handleYearSelect = (date) => {
		const selectedYear = moment(date).year();
		if (!selectedYear || selectedYear < minAllowedYear || selectedYear > maxAllowedYear) return;
		setYear(selectedYear);
		handleItemClicked('Selected Year');
	}

	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: 'Fleet CashFlow', page_type: page_type, })
	}

	const cashflowFilterMenu = {
		start_date: { title: 'From Date', inputType: 'date',disableFuture:true },
		end_date: { title: 'To Date', inputType: 'date',disableFuture:true  },
		lessor_ids: { title: 'Lessor/Holdco', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: true },
		lessee_ids: { title: 'Lessee', inputType: 'dropdown', options: lessee, valueKey: 'id', labelKey: 'name', multiple: true },
		asset: { title: 'Asset', inputType: 'dropdown', options: assetList || [], valueKey: 'unique_key', labelKey: 'name', multiple: true,renderOption: (props, option) => ( <Box component="li" {...props} key={option.slug || option.unique_key}> {option.name} </Box>) },
		lease_status: { title: 'Lease Status', inputType: 'dropdown', options: statusLabel, valueKey: 'id', labelKey: 'Label', multiple: true },
		transaction_types: { title: 'Transaction Type', inputType: 'dropdown', options: transactionTypes, valueKey: 'id', labelKey: 'name' },
		show_only: { title: 'Show Only', inputType: 'dropdown', options: showOnlyOption, valueKey: 'value', labelKey: 'label' },
		sections: { title: 'Cashflow Categories', inputType: 'dropdown', options: section, valueKey: 'name', labelKey: 'name' },
		hide_no_activity: { title: 'Hide rows with no activity', inputType: 'checkbox', value: true },
		hide_empty_sections: { title: 'Hide Empty Sections', inputType: 'checkbox', value: true },
	};
	const onApplyFilter = (query) => {
		if (query.start_date && query.end_date && moment(query.start_date).isAfter(moment(query.end_date))) {
			enqueueSnackbar('From Date must be before To Date', { variant: 'error' });
			return false;
		}
		const fromDate = query?.start_date && moment(query?.start_date).format('YYYY')  
		const toDate= query?.end_date && moment(query?.end_date).format('YYYY')
		const selectedYear = query.year || (fromDate ? fromDate : toDate || year);
		if (query.year) {
			setYear(query.year);
		}
		getCashFlowList("", mode, selectedYear, currency, query);
	};

	const handleExport = (fileType) => {
		const fromDate = filter?.start_date && moment(filter?.start_date).format('YYYY')
		const toDate= filter?.end_date && moment(filter?.end_date).format('YYYY')
		const selectedYear = (fromDate ? fromDate : toDate || year);

		const apiFilter = { ...filter };
		if (apiFilter.asset) {
			debugger
			const selectedAssets = Array.isArray(apiFilter.asset) ? apiFilter.asset : apiFilter.asset.toString().split(',').filter(Boolean);
			apiFilter.asset = selectedAssets.map((key) => {
				const [id, assetType] = key.toString().split('_');
				return assetType ? `${id},${assetType}` : key;
			}).join(',');
		}

		let query = { ...apiFilter, file_type: fileType, scope: 'fleet', currency: currency, year: selectedYear, mode: mode }

		setExport(true);
		globalGetService(exportCashFlowApi(query)).then((response) => {
			if (checkApiStatus(response)) {
				enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			setExport(false);
		})
	}

	return (
		<section className="active-asset-section" style={{marginTop: "-7px"}}>
			<DeploymentBanner />
			<Paper elevation={0} className="lease-details-section lease-module-paper" style={{ height: `${window.innerHeight - 80}px`, display: 'flex', flexDirection: 'column', overflow: 'hidden' }} >
				<Tabs value={tabIndex} onChange={(event, newValue) => setTabIndex(newValue)} style={{ margin: '10px 10px 0px 10px', flexShrink: 0,boxShadow: "0px 0px 2px 0.5px #BBBBBB"  }}>
					<Tab label="Cashflow" />
					<Tab label="Receivable" />
				</Tabs>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					{tabIndex === 1 ? (
						<ReceivableCashflow />
					) : (
					<>
						<div className="lease-details-content" style={{ padding: "0px 10px 0px 0px", margin: "10px 0px 0px 10px", height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
							<div className="responsive-paper" style={{ flexShrink: 0 }}>
								<Grid container spacing={1} style={{placeItems:'flex-start'}}>
									<Grid size={'grow'} item xs={12} sx={{ minWidth: 0 }}>
										<div>
											<FilterComponent filter={filter} filterMenu={cashflowFilterMenu} getResponseBack={(query) => onApplyFilter(query)}/>
										</div>
									</Grid>
									<Grid size={{ md: 'auto', xs: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
										<ul className="list-inline  lease-details-btn">
										   {!(filter?.start_date || filter?.end_date ) ?
											<li className="list-inline-item lease-mobile-button" style={{marginInline:'4px',verticalAlign:"middle"}}>
												<LocalizationProvider dateAdapter={AdapterMoment}>
													<DatePicker
														views={['year']}
														openTo="year"
														value={moment().year(year)}
														minDate={moment().year(minAllowedYear).startOf('year')}
														maxDate={moment().year(maxAllowedYear).endOf('year')}
														format="YYYY"
														onChange={handleYearSelect}
														slotProps={{
															textField: {
																size: 'small',
																variant: 'outlined',
																helperText: '',
																sx: {
																	width: '85px',
																	'& .MuiOutlinedInput-root': {
																		height: '30px',
																		borderRadius: '4px',
																		backgroundColor: '#fff',
																		'& fieldset': { borderColor: '#b6bbe8' },
																		'&:hover fieldset': { borderColor: 'primary.main' },
																		'&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: '1px' },
																	},
																	'& .MuiOutlinedInput-input': {
																		padding: '0 0 0 8px',
																		fontSize: '14px',
																		fontWeight: 500,
																		color: 'primary.main',
																		cursor: 'pointer',
																	},
																	'& .MuiIconButton-root': {
																		color: 'primary.main',
																		padding: '2px',
																		marginRight: '2px',
																	},
																	'& .MuiSvgIcon-root': { fontSize: '14px' },
																},
															},
														}}
													/>
												</LocalizationProvider>
											</li>: null}
											{<li className="list-inline-item lease-mobile-button" style={{marginInline:'4px'}}>
												<PopOverCTA btnText={currencyLabel} onCloseItem={true} menuMaxHeight={450}>
													<>
														{currencyOptions.map((currency) => (
															<MenuItem key={currency.id} sx={{background: currencyLabel === currency.code ? '#d6d4d4' : 'inherit',fontSize:'13px' }} onClick={() => { handleCurrencyChange(currency.code); handleItemClicked(`Clicked on ${currency.code}`); }} >{currency.code}</MenuItem>
														))}
													</>
												</PopOverCTA>
											</li>}
											{cashFlowListing?.mode ? <li className="lease-mobile-button">
												<PopOverCTA btnText={cashFlowListing?.mode}  onCloseItem={true}>
													<>
														<MenuItem sx={{ background: cashFlowListing?.mode?.toUpperCase() === 'MONTHLY' ? '#d6d4d4' : 'inherit',fontSize:'13px' }} onClick={() => { handleModeChange('MONTHLY'); handleItemClicked('Clicked on Monthly')}}>MONTHLY</MenuItem>
														<MenuItem sx={{ background: cashFlowListing?.mode?.toUpperCase() === 'QUARTERLY' ? '#d6d4d4' : 'inherit',fontSize:'13px' }} onClick={() => { handleModeChange('QUARTERLY'); handleItemClicked('Clicked on Quarterly')}}>QUARTERLY</MenuItem>
														<MenuItem sx={{ background: cashFlowListing?.mode?.toUpperCase() === 'YEARLY' ? '#d6d4d4' : 'inherit',fontSize:'13px' }} onClick={() => { handleModeChange('YEARLY'); handleItemClicked('Clicked on Yearly')}}>YEARLY</MenuItem>
													</>
												</PopOverCTA>
											</li> : null}
											{cashFlowListing?.data?.length ? <li className="lease-mobile-button" style={{marginInline:'4px'}}>
												<ExportFileTypeComp handelExport={handleExport} isLoading={isExport}/>
											</li> : null }
										</ul>
									</Grid>
								</Grid>
							</div>
							<Paper className="lease-detail-table lease-module-paper " style={{ marginTop: "0px", flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }} elevation={0}>
								{skeletonLoader ? (
									<STableLoader count={6} rowCount={10} />
								) : (
									<div style={{ flex: 1, minHeight: 0, padding: "5px", display: 'flex', flexDirection: 'column', overflow: 'hidden' }} >
										<CashFlowListing cashFlowListing={cashFlowListing} selectedCurrency={currencyLabel} currencySymbol={currencySymbol} onOpenDetails={(payload) => setCashflowDetailsModal({ open: true, ...payload })} handleItemClicked={handleItemClicked} />
									</div>
								)}
								{isLoading ? <PageLoader /> : null}
							</Paper>
						</div>
						{cashflowDetailsModal.open && (
							<CashflowDetailsModal open={cashflowDetailsModal.open} onClose={() => setCashflowDetailsModal({ open: false, start_date: null, end_date: null, mode: "monthly" })} start_date={cashflowDetailsModal.start_date} end_date={cashflowDetailsModal.end_date} mode={cashflowDetailsModal.mode} currency={currencyLabel}  filter={filter} handleItemClicked={handleItemClicked} />
						)}
					</>
					)}
				</Box>
			</Paper>
		</section>
	)
}

export default RoleBaseAccess(FleetCashflow, { application: 'lease_revamp', feature: 'cashflow', operationType: ['R'] });
